import iro from "@jaames/iro";

export default class LogPrimaries {
	constructor() {
		this.blockName = "log-primaries";
		this.passNames = [
			"Log-primaries-wheel-shadows-Y",
			"Log-primaries-wheel-shadows-RGB",
			"Log-primaries-wheel-midtones-Y",
			"Log-primaries-wheel-midtones-RGB",
			"Log-primaries-wheel-highlights-Y",
			"Log-primaries-wheel-highlights-RGB",
			"Log-primaries-wheel-offset-Y",
			"Log-primaries-wheel-offset-RGB",
			"Log-primaries-sliders-shadows-Y",
			"Log-primaries-sliders-shadows-RGB",
			"Log-primaries-sliders-midtones-Y",
			"Log-primaries-sliders-midtones-RGB",
			"Log-primaries-sliders-highlights-Y",
			"Log-primaries-sliders-highlights-RGB",
			"Log-primaries-sliders-offset-Y",
			"Log-primaries-sliders-offset-RGB",
		];
		this.curveNames = [
			"LogPrimaries-Shadows-Y",
			"LogPrimaries-Shadows-R",
			"LogPrimaries-Shadows-G",
			"LogPrimaries-Shadows-B",
			"LogPrimaries-Midtones-Y",
			"LogPrimaries-Midtones-R",
			"LogPrimaries-Midtones-G",
			"LogPrimaries-Midtones-B",
			"LogPrimaries-Highlights-Y",
			"LogPrimaries-Highlights-R",
			"LogPrimaries-Highlights-G",
			"LogPrimaries-Highlights-B",
			"LogPrimaries-Offset-Y",
			"LogPrimaries-Offset-R",
			"LogPrimaries-Offset-G",
			"LogPrimaries-Offset-B",
		];

		this.opacity = {
			minValue: 0,
			maxValue: 100,
		};
	}

	addBlock(blockNum = lutify.blocks.length) {
		UI.createAdjustmentBlockTemplate(this.blockName, blockNum);
		let element = UI.getAdjustmentBlock(blockNum);

		$(element)
			.find(".control-selector__items-container > span")
			.on("click", (e, animate) => this.controlSelection(e.currentTarget, animate));
		$(element)
			.find(".btn-reset-block")
			.off("click")
			.on("click", _ => this.resetBlock($(element)));
		$(element)
			.find(".colorwheel-container")
			.on("dblclick", e => this.resetColorWheel($(e.currentTarget)));
		$(element)
			.find('.block-controls-container[data-control="sliders"] .slider-control')
			.on("dblclick", e => this.resetVerticalSlider($(e.currentTarget)));

		$(element)
			.find(".expand_options")
			.trigger("click", [false]);
		$(element)
			.find('.control-selector__items-container > span[data-control="wheels"]')
			.trigger("click", [false]);

		$(element)
			.find('.block-controls-container[data-control="wheels"] .slider-control')
			.on("input", e => this.sliderHandler($(e.currentTarget)));
		$(element)
			.find('.block-controls-container[data-control="wheels"] .slider-input-control')
			.on("change", e => this.sliderInputHandler($(e.currentTarget)));

		$(element)
			.find('.block-controls-container[data-control="sliders"] .slider-control')
			.on("input", e => this.verticalSliderHandler($(e.currentTarget)));
		$(element)
			.find('.block-controls-container[data-control="sliders"] .slider-input-control')
			.on("change", e => this.verticalSliderInputHandler($(e.currentTarget)));

		$(element).find(".opacity_slider").on("input", () => this.opacitySliderHandler($(element)));
		$(element).find(".opacity-input").on("change", () => this.opacityInputHandler($(element)));

		$(element)
			.find(".control-selector__label-container")
			.on("click", e => {
				e.stopPropagation();
				this.toggleControlSelector($(e.currentTarget));
			});

		UI.initKnob(element);

		blocks.add({
			name: "logPrimaries",
			passes: this.addPasses(),
			blockNum,
			blendingMode: 0,
			blendingModeName: "Normal",
			opacity: 100,
			curves: [],
			values: {
				wheels: {
					shadows: { Y: 0, R: 1.0, G: 1.0, B: 1.0 },
					midtones: { Y: 0, R: 1.0, G: 1.0, B: 1.0 },
					highlights: { Y: 0, R: 1.0, G: 1.0, B: 1.0 },
					offset: { Y: 0, R: 1.0, G: 1.0, B: 1.0 },
				},
				sliders: {
					shadows: { Y: 0, R: 0, G: 0, B: 0 },
					midtones: { Y: 0, R: 0, G: 0, B: 0 },
					highlights: { Y: 0, R: 0, G: 0, B: 0 },
					offset: { Y: 0, R: 0, G: 0, B: 0 },
				},
			},
			colorWheels: this.colorWheelsInit($(element)),
		});

		this.slidersInit($(element));
		blocks.createCurves(this.curveNames, blockNum);

		// Average blending mode
		$(element).find(`.blending-mode__items-container > span[data-id="22"]`).trigger("click");
	}

	addPasses() {
		let passes = [];
		this.passNames.forEach(passName => {
			let shaderPass = gpu.createCurveShaderPass(passName);
			gpu.addPassToComposer(shaderPass, "toMiddle");
			passes.push(shaderPass);
		});

		return passes;
	}

	colorWheelsInit($element) {
		let colorWheels = [];
		let colorWheelContainers = $element.find(".colorwheel-container");

		for (let i = 0; i < 4; i++) {
			let colorWheel = new iro.ColorPicker(colorWheelContainers[i], config.colorWheelOptions);
			colorWheel.on("color:change", colors => this.colorChangeHandler(colorWheelContainers[i], colors));
			colorWheels.push(colorWheel);
		}

		return colorWheels;
	}

	slidersInit($element) {
		$element.find('.block-controls-container[data-control="sliders"] .slider-control').slider({
			orientation: "vertical",
			width: 1,
			range: "min",
			min: -1,
			max: 1,
			step: 0.001,
			value: 0,
			change: (event, ui) => this.verticalSliderHandler(event, ui),
			slide: (event, ui) => this.verticalSliderHandler(event, ui),
		});

		$element.find('.block-controls-container[data-control="sliders"] .slider-control').each((index, sliderControl) => {
			let html = document.createElement("div");
			html.setAttribute("class", "slider-control-fill");
			$(sliderControl).append(html);
		});
	}

	toggleControlSelector($el) {
		let itemsContainer = $el.siblings(".control-selector__items-container");
		if (itemsContainer.is(":visible")) itemsContainer.hide();
		else itemsContainer.show();
	}

	controlSelection(selectedControl, animate = true) {
		let $blockOptions = $(selectedControl).closest(".block_options");
		$blockOptions.find(".control-selector__items-container").hide();
		$blockOptions.find(".selected-control-name").html($(selectedControl).html());
		if (animate) {
			$blockOptions.find(".block-controls-container").fadeOut(2);
			$blockOptions.find(`.block-controls-container[data-control="${selectedControl.dataset.control}"]`).fadeIn();
		} else {
			$blockOptions.find(`.block-controls-container[data-control="${selectedControl.dataset.control}"]`).show();
		}
	}

	colorChangeHandler(colorWheelElement, colors) {
		blocks.checkSwitchHandler($(colorWheelElement).closest(".adjustment-block"));
		lutify.setActiveBlock(
			parseInt(
				$(colorWheelElement)
					.closest(".adjustment-block")
					.attr("orignum")
			)
		);

		let controlName = $(colorWheelElement)
			.data("curve")
			.split("-")[0];
		// let controlCurve = $(colorWheelElement).data('curve').split('-')[1];
		let passIndex = $(colorWheelElement).data("pass-index");

		lutify.getActiveBlock().passes[passIndex].enabled = true;
		lutify.getActiveBlock().activePassIndex = passIndex;

		let newColors = {
			r: (colors.rgb.r / 255).toFixed(3),
			g: (colors.rgb.g / 255).toFixed(3),
			b: (colors.rgb.b / 255).toFixed(3),
		};

		lutify.getActiveBlock().values.wheels[controlName].R = newColors.r;
		lutify.getActiveBlock().values.wheels[controlName].G = newColors.g;
		lutify.getActiveBlock().values.wheels[controlName].B = newColors.b;

		if (!UI.mouse.knobDrag) {
			$(colorWheelElement)
				.closest(".control-container")
				.find(`.slider-input-control[data-curve="${controlName}-R"]`)
				.val(newColors.r);
			$(colorWheelElement)
				.closest(".control-container")
				.find(`.slider-input-control[data-curve="${controlName}-G"]`)
				.val(newColors.g);
			$(colorWheelElement)
				.closest(".control-container")
				.find(`.slider-input-control[data-curve="${controlName}-B"]`)
				.val(newColors.b);
		}

		this[`${controlName}RGBCurve`]([colors.rgb.r, colors.rgb.g, colors.rgb.b]);
	}

	sliderHandler($sliderElement) {
		let controlName = $sliderElement.data("curve").split("-")[0];
		let controlCurve = $sliderElement.data("curve").split("-")[1];
		let passIndex = $sliderElement.data("pass-index");

		blocks.checkSwitchHandler($sliderElement.closest(".adjustment-block"));
		lutify.getActiveBlock().activePassIndex = passIndex;
		lutify.getActiveBlock().values.wheels[controlName].Y = $sliderElement.val();

		lutify.getActiveBlock().passes[passIndex].enabled = true;
		$sliderElement
			.closest(".control-container")
			.find(`.slider-input-control[data-curve="${controlName}-Y"]`)
			.val($sliderElement.val());
		this[`${controlName}${controlCurve}Curve`]($sliderElement.val());
	}

	sliderInputHandler($sliderInputElement) {
		blocks.checkSwitchHandler($sliderInputElement.closest(".adjustment-block"));

		let controlName = $sliderInputElement.data("curve").split("-")[0];
		let controlCurve = $sliderInputElement.data("curve").split("-")[1];
		let passIndex = $sliderInputElement.data("pass-index");

		lutify.getActiveBlock().passes[passIndex].enabled = true;
		lutify.getActiveBlock().activePassIndex = passIndex;

		if ($sliderInputElement.val() > parseFloat($sliderInputElement.attr("max"))) $sliderInputElement.val($sliderInputElement.attr("max"));
		if ($sliderInputElement.val() < parseFloat($sliderInputElement.attr("min"))) $sliderInputElement.val($sliderInputElement.attr("min"));

		lutify.getActiveBlock().values.wheels[controlName][controlCurve] = $sliderInputElement.val();

		// slider R,G,B
		if (controlCurve == "R" || controlCurve == "G" || controlCurve == "B") {
			let colors = {
				r: (
					parseFloat(
						$sliderInputElement
							.closest(".control-container")
							.find(`.slider-input-control[data-curve=${controlName}-R]`)
							.val()
					) * 255
				).toFixed(3),
				g: (
					parseFloat(
						$sliderInputElement
							.closest(".control-container")
							.find(`.slider-input-control[data-curve=${controlName}-G]`)
							.val()
					) * 255
				).toFixed(3),
				b: (
					parseFloat(
						$sliderInputElement
							.closest(".control-container")
							.find(`.slider-input-control[data-curve=${controlName}-B]`)
							.val()
					) * 255
				).toFixed(3),
			};

			if (controlName == "shadows") lutify.getActiveBlock().colorWheels[0].color.rgb = colors;
			else if (controlName == "midtones") lutify.getActiveBlock().colorWheels[1].color.rgb = colors;
			else if (controlName == "highlights") lutify.getActiveBlock().colorWheels[2].color.rgb = colors;
			else if (controlName == "offset") lutify.getActiveBlock().colorWheels[3].color.rgb = colors;
		}

		// slider Y
		else {
			let $sliderControlElement = $sliderInputElement.closest(".control-container").find(`.slider-control[data-curve="${controlName}-Y"]`);
			$sliderControlElement.val($sliderInputElement.val());
			$sliderControlElement.trigger("input");
		}
	}

	verticalSliderHandler(event, ui) {
		let $sliderControlElement = $(event.target);
		let controlName = $sliderControlElement.data("curve").split("-")[0];
		let controlCurve = $sliderControlElement.data("curve").split("-")[1];
		let passIndex = $sliderControlElement.data("pass-index");

		lutify.getActiveBlock().values.sliders[controlName][controlCurve] = ui.value;
		lutify.getActiveBlock().activePassIndex = passIndex;
		lutify.getActiveBlock().passes[passIndex].enabled = true;

		if (controlCurve == "R" || controlCurve == "G" || controlCurve == "B") {
			let valueR = lutify.getActiveBlock().values.sliders[controlName]["R"];
			let valueG = lutify.getActiveBlock().values.sliders[controlName]["G"];
			let valueB = lutify.getActiveBlock().values.sliders[controlName]["B"];
			this[`${controlName}RGBCurve`]([valueR, valueG, valueB], false);
		} else {
			// curve Y
			this[`${controlName}${controlCurve}Curve`](lutify.getActiveBlock().values.sliders[controlName][controlCurve]);
		}

		let $sliderInputElement = $sliderControlElement
			.closest(".control-container")
			.find(`.slider-input-control[data-curve="${controlName}-${controlCurve}"]`);
		$sliderInputElement.val(ui.value);

		this.updateSliderUI($(event.target).closest(".slider-control"), ui.value);
		blocks.checkSwitchHandler($(event.target).closest(".adjustment-block"));
	}

	verticalSliderInputHandler($sliderInputElement) {
		let controlName = $sliderInputElement.data("curve").split("-")[0];
		let controlCurve = $sliderInputElement.data("curve").split("-")[1];

		lutify.getActiveBlock().values.sliders[controlName][controlCurve] = $sliderInputElement.val();

		let $sliderControlElement = $sliderInputElement
			.closest(".control-container")
			.find(`.slider-control[data-curve="${controlName}-${controlCurve}"]`);
		$sliderControlElement.slider("value", $sliderInputElement.val());

		blocks.checkSwitchHandler($sliderInputElement.closest(".adjustment-block"));
	}

	shadowsYCurve(shadowsValue) {
		let curve = lutify.getActiveBlock().curves[0].colorCurve;
		curve.points = [];

		if (shadowsValue >= 0) {
			curve.points.push({ x: 0.0, y: 0.0 + shadowsValue * 0.274 });
			curve.points.push({ x: 0.588, y: 0.588 });
			curve.points.push({ x: 0.686, y: 0.686 });
			curve.points.push({ x: 0.784, y: 0.784 });
			curve.points.push({ x: 1.0, y: 1.0 });
		} else {
			curve.points.push({ x: 0.0 + Math.abs(shadowsValue) * 0.274, y: 0.0 });
			curve.points.push({ x: 0.588, y: 0.588 });
			curve.points.push({ x: 0.686, y: 0.686 });
			curve.points.push({ x: 0.784, y: 0.784 });
			curve.points.push({ x: 1.0, y: 1.0 });
		}

		curve.draw();
		curve.updateValues();
		this.callGPUShadowsY(curve.rgb);
	}

	shadowsRGBCurve(shadowsValues, calcValue = true) {
		let curves = [];
		curves[0] = lutify.getActiveBlock().curves[1].colorCurve;
		curves[1] = lutify.getActiveBlock().curves[2].colorCurve;
		curves[2] = lutify.getActiveBlock().curves[3].colorCurve;

		shadowsValues.forEach((shadowsValue, index) => {
			curves[index].points = [];

			// For wheels
			if (calcValue) {
				shadowsValue = (255 - shadowsValue) / 255;
				curves[index].points.push({ x: 0.0 + shadowsValue * 0.274, y: 0.0 });
				curves[index].points.push({ x: 0.588, y: 0.588 });
				curves[index].points.push({ x: 0.686, y: 0.686 });
				curves[index].points.push({ x: 0.784, y: 0.784 });
				curves[index].points.push({ x: 1.0, y: 1.0 });
			}

			// For sliders
			else {
				if (shadowsValue >= 0) {
					curves[index].points.push({ x: 0.0, y: 0.0 + shadowsValue * 0.274 });
					curves[index].points.push({ x: 0.588, y: 0.588 });
					curves[index].points.push({ x: 0.686, y: 0.686 });
					curves[index].points.push({ x: 0.784, y: 0.784 });
					curves[index].points.push({ x: 1.0, y: 1.0 });
				} else {
					curves[index].points.push({ x: 0.0 + Math.abs(shadowsValue) * 0.274, y: 0.0 });
					curves[index].points.push({ x: 0.588, y: 0.588 });
					curves[index].points.push({ x: 0.686, y: 0.686 });
					curves[index].points.push({ x: 0.784, y: 0.784 });
					curves[index].points.push({ x: 1.0, y: 1.0 });
				}
			}

			curves[index].draw();
			curves[index].updateValues();
		});

		this.callGPUShadowsRGB(curves[0].rgb, curves[1].rgb, curves[2].rgb);
	}

	midtonesYCurve(midtonesValue) {
		let curve = lutify.getActiveBlock().curves[4].colorCurve;
		curve.points = [];

		if (midtonesValue >= 0) {
			curve.points.push({ x: 0.0, y: 0.0 });
			curve.points.push({ x: 0.094, y: 0.094 });
			curve.points.push({ x: 0.156, y: 0.156 });
			curve.points.push({ x: 0.235, y: 0.235 + midtonesValue * 0.074 });
			curve.points.push({ x: 0.4, y: 0.4 + midtonesValue * 0.215 });
			curve.points.push({ x: 0.64, y: 0.64 + midtonesValue * 0.089 });
			curve.points.push({ x: 0.847, y: 0.847 });
			curve.points.push({ x: 0.941, y: 0.941 });
			curve.points.push({ x: 1.0, y: 1.0 });
		} else {
			curve.points.push({ x: 0.0, y: 0.0 });
			curve.points.push({ x: 0.094, y: 0.094 });
			curve.points.push({ x: 0.156, y: 0.156 });
			curve.points.push({ x: 0.435, y: 0.435 - Math.abs(midtonesValue) * 0.173 });
			curve.points.push({ x: 0.607, y: 0.607 - Math.abs(midtonesValue) * 0.243 });
			curve.points.push({ x: 0.78, y: 0.78 - Math.abs(midtonesValue) * 0.051 });
			curve.points.push({ x: 0.847, y: 0.847 });
			curve.points.push({ x: 0.941, y: 0.941 });
			curve.points.push({ x: 1.0, y: 1.0 });
		}

		curve.draw();
		curve.updateValues();
		this.callGPUMidtonesY(curve.rgb);
	}

	midtonesRGBCurve(midtonesValues, calcValue = true) {
		let curves = [];
		curves[0] = lutify.getActiveBlock().curves[5].colorCurve;
		curves[1] = lutify.getActiveBlock().curves[6].colorCurve;
		curves[2] = lutify.getActiveBlock().curves[7].colorCurve;

		midtonesValues.forEach((midtonesValue, index) => {
			curves[index].points = [];

			// For wheels
			if (calcValue) {
				midtonesValue = (255 - midtonesValue) / 255;
				curves[index].points.push({ x: 0.0, y: 0.0 });
				curves[index].points.push({ x: 0.094, y: 0.094 });
				curves[index].points.push({ x: 0.156, y: 0.156 });
				curves[index].points.push({ x: 0.435, y: 0.435 - midtonesValue * 0.173 });
				curves[index].points.push({ x: 0.607, y: 0.607 - midtonesValue * 0.243 });
				curves[index].points.push({ x: 0.78, y: 0.78 - midtonesValue * 0.051 });
				curves[index].points.push({ x: 0.847, y: 0.847 });
				curves[index].points.push({ x: 0.941, y: 0.941 });
				curves[index].points.push({ x: 1.0, y: 1.0 });
			}

			// For sliders
			else {
				if (midtonesValue >= 0) {
					curves[index].points.push({ x: 0.0, y: 0.0 });
					curves[index].points.push({ x: 0.094, y: 0.094 });
					curves[index].points.push({ x: 0.156, y: 0.156 });
					curves[index].points.push({ x: 0.235, y: 0.235 + midtonesValue * 0.074 });
					curves[index].points.push({ x: 0.4, y: 0.4 + midtonesValue * 0.215 });
					curves[index].points.push({ x: 0.64, y: 0.64 + midtonesValue * 0.089 });
					curves[index].points.push({ x: 0.847, y: 0.847 });
					curves[index].points.push({ x: 0.941, y: 0.941 });
					curves[index].points.push({ x: 1.0, y: 1.0 });
				} else {
					curves[index].points.push({ x: 0.0, y: 0.0 });
					curves[index].points.push({ x: 0.094, y: 0.094 });
					curves[index].points.push({ x: 0.156, y: 0.156 });
					curves[index].points.push({ x: 0.435, y: 0.435 - Math.abs(midtonesValue) * 0.173 });
					curves[index].points.push({ x: 0.607, y: 0.607 - Math.abs(midtonesValue) * 0.243 });
					curves[index].points.push({ x: 0.78, y: 0.78 - Math.abs(midtonesValue) * 0.051 });
					curves[index].points.push({ x: 0.847, y: 0.847 });
					curves[index].points.push({ x: 0.941, y: 0.941 });
					curves[index].points.push({ x: 1.0, y: 1.0 });
				}
			}

			curves[index].draw();
			curves[index].updateValues();
		});

		this.callGPUMidtonesRGB(curves[0].rgb, curves[1].rgb, curves[2].rgb);
	}

	highlightsYCurve(highlightsValue) {
		let curve = lutify.getActiveBlock().curves[8].colorCurve;
		curve.points = [];

		if (highlightsValue >= 0) {
			curve.points.push({ x: 0.0, y: 0.0 });
			curve.points.push({ x: 0.125, y: 0.125 });
			curve.points.push({ x: 0.188, y: 0.188 });
			curve.points.push({ x: 0.255, y: 0.255 });
			curve.points.push({ x: 1.0 - highlightsValue * 0.314, y: 1.0 });
		} else {
			curve.points.push({ x: 0.0, y: 0.0 });
			curve.points.push({ x: 0.125, y: 0.125 });
			curve.points.push({ x: 0.188, y: 0.188 });
			curve.points.push({ x: 0.255, y: 0.255 });
			curve.points.push({ x: 0.47, y: 0.47 - Math.abs(highlightsValue) * 0.09 });
			curve.points.push({ x: 0.627, y: 0.627 - Math.abs(highlightsValue) * 0.204 });
			curve.points.push({ x: 1.0, y: 1.0 - Math.abs(highlightsValue) * 0.5 });
		}

		curve.draw();
		curve.updateValues();
		this.callGPUHighlightsY(curve.rgb);
	}

	highlightsRGBCurve(highlightsValues, calcValue = true) {
		let curves = [];
		curves[0] = lutify.getActiveBlock().curves[9].colorCurve;
		curves[1] = lutify.getActiveBlock().curves[10].colorCurve;
		curves[2] = lutify.getActiveBlock().curves[11].colorCurve;

		highlightsValues.forEach((highlightsValue, index) => {
			curves[index].points = [];

			// For wheels
			if (calcValue) {
				highlightsValue = (255 - highlightsValue) / 255;
				curves[index].points.push({ x: 0.0, y: 0.0 });
				curves[index].points.push({ x: 0.125, y: 0.125 });
				curves[index].points.push({ x: 0.188, y: 0.188 });
				curves[index].points.push({ x: 0.255, y: 0.255 });
				curves[index].points.push({ x: 0.47, y: 0.47 - highlightsValue * 0.09 });
				curves[index].points.push({ x: 0.627, y: 0.627 - highlightsValue * 0.204 });
				curves[index].points.push({ x: 1.0, y: 1.0 - highlightsValue * 0.5 });
			}

			// For sliders
			else {
				if (highlightsValue >= 0) {
					curves[index].points.push({ x: 0.0, y: 0.0 });
					curves[index].points.push({ x: 0.125, y: 0.125 });
					curves[index].points.push({ x: 0.188, y: 0.188 });
					curves[index].points.push({ x: 0.255, y: 0.255 });
					curves[index].points.push({ x: 1.0 - highlightsValue * 0.314, y: 1.0 });
				} else {
					curves[index].points.push({ x: 0.0, y: 0.0 });
					curves[index].points.push({ x: 0.125, y: 0.125 });
					curves[index].points.push({ x: 0.188, y: 0.188 });
					curves[index].points.push({ x: 0.255, y: 0.255 });
					curves[index].points.push({ x: 0.47, y: 0.47 - Math.abs(highlightsValue) * 0.09 });
					curves[index].points.push({ x: 0.627, y: 0.627 - Math.abs(highlightsValue) * 0.204 });
					curves[index].points.push({ x: 1.0, y: 1.0 - Math.abs(highlightsValue) * 0.5 });
				}
			}

			curves[index].draw();
			curves[index].updateValues();
		});

		this.callGPUHighlightsRGB(curves[0].rgb, curves[1].rgb, curves[2].rgb);
	}

	offsetYCurve(offsetVal) {
		let curve = lutify.getActiveBlock().curves[12].colorCurve;
		curve.points = [];

		if (offsetVal > 0) {
			curve.points.push({ x: 0.0, y: offsetVal * 0.003921 * 128 });
			curve.points.push({ x: 1.0 - Math.abs(offsetVal) * 0.003921 * 128, y: 1.0 });
		} else {
			curve.points.push({ x: Math.abs(offsetVal) * 0.003921 * 128, y: 0.0 });
			curve.points.push({ x: 1.0, y: 1.0 - Math.abs(offsetVal) * 0.003921 * 128 });
		}

		curve.draw();
		curve.updateValues();
		this.callGPUOffsetY(curve.rgb);
	}

	offsetRGBCurve(offsetValues, calcValue = true) {
		let curves = [];
		curves[0] = lutify.getActiveBlock().curves[13].colorCurve;
		curves[1] = lutify.getActiveBlock().curves[14].colorCurve;
		curves[2] = lutify.getActiveBlock().curves[15].colorCurve;

		offsetValues.forEach((offsetValue, index) => {
			curves[index].points = [];

			// For wheels
			if (calcValue) {
				offsetValue = (255 - offsetValue) / 255;
				curves[index].points.push({ x: offsetValue * 0.003921 * 128, y: 0.0 });
				curves[index].points.push({ x: 1.0, y: 1.0 - offsetValue * 0.003921 * 128 });
			}

			// For sliders
			else {
				if (offsetValue > 0) {
					curves[index].points.push({ x: 0.0, y: offsetValue * 0.003921 * 128 });
					curves[index].points.push({ x: 1.0 - Math.abs(offsetValue) * 0.003921 * 128, y: 1.0 });
				} else {
					curves[index].points.push({ x: Math.abs(offsetValue) * 0.003921 * 128, y: 0.0 });
					curves[index].points.push({ x: 1.0, y: 1.0 - Math.abs(offsetValue) * 0.003921 * 128 });
				}
			}

			curves[index].draw();
			curves[index].updateValues();
		});

		this.callGPUOffsetRGB(curves[0].rgb, curves[1].rgb, curves[2].rgb);
	}

	callGPUShadowsY(points) {
		let curveTexture = gpu.pointsToCurve(points);
		let passIndex = lutify.getActiveBlock().activePassIndex;
		lutify.getActiveBlock().passes[passIndex].uniforms["map"].value = curveTexture;
		gpu.render();
	}

	callGPUShadowsRGB(pointsR, pointsG, pointsB) {
		let curveTexture = gpu.RGBPointsToCurve(pointsR, pointsG, pointsB);
		let passIndex = lutify.getActiveBlock().activePassIndex;
		lutify.getActiveBlock().passes[passIndex].uniforms["map"].value = curveTexture;
		gpu.render();
	}

	callGPUMidtonesY(points) {
		let curveTexture = gpu.pointsToCurve(points);
		let passIndex = lutify.getActiveBlock().activePassIndex;
		lutify.getActiveBlock().passes[passIndex].uniforms["map"].value = curveTexture;
		gpu.render();
	}

	callGPUMidtonesRGB(pointsR, pointsG, pointsB) {
		let curveTexture = gpu.RGBPointsToCurve(pointsR, pointsG, pointsB);
		let passIndex = lutify.getActiveBlock().activePassIndex;
		lutify.getActiveBlock().passes[passIndex].uniforms["map"].value = curveTexture;
		gpu.render();
	}

	callGPUHighlightsY(points) {
		let curveTexture = gpu.pointsToCurve(points);
		let passIndex = lutify.getActiveBlock().activePassIndex;
		lutify.getActiveBlock().passes[passIndex].uniforms["map"].value = curveTexture;
		gpu.render();
	}

	callGPUHighlightsRGB(pointsR, pointsG, pointsB) {
		let curveTexture = gpu.RGBPointsToCurve(pointsR, pointsG, pointsB);
		let passIndex = lutify.getActiveBlock().activePassIndex;
		lutify.getActiveBlock().passes[passIndex].uniforms["map"].value = curveTexture;
		gpu.render();
	}

	callGPUOffsetY(points) {
		let curveTexture = gpu.pointsToCurve(points);
		let passIndex = lutify.getActiveBlock().activePassIndex;
		lutify.getActiveBlock().passes[passIndex].uniforms["map"].value = curveTexture;
		gpu.render();
	}

	callGPUOffsetRGB(pointsR, pointsG, pointsB) {
		let curveTexture = gpu.RGBPointsToCurve(pointsR, pointsG, pointsB);
		let passIndex = lutify.getActiveBlock().activePassIndex;
		lutify.getActiveBlock().passes[passIndex].uniforms["map"].value = curveTexture;
		gpu.render();
	}

	resetBlock($element) {
		let $sliderInputControls = $element.find(".slider-input-control");
		$sliderInputControls.each(function() {
			$(this).val($(this).data("default-value"));
		});
		$sliderInputControls.trigger("change");
		lutify.getActiveBlock().passes.forEach(pass => (pass.enabled = false));
	}

	resetColorWheel($colorWheelContainer) {
		// let controlName = $colorWheelContainer.data('curve').split('-')[0];
		let controlCurve = $colorWheelContainer.data("curve").split("-")[1];
		let passIndex = $colorWheelContainer.data("pass-index");
		let $sliderInputControls = $colorWheelContainer.closest(".control-container").find(".slider-input-control");

		$sliderInputControls.each(function(i) {
			if (i !== 0) {
				$(this).val($(this).data("default-value"));
				$(this).trigger("change");
			}
		});

		lutify.getActiveBlock().passes[passIndex].enabled = false;
	}

	resetVerticalSlider($slider) {
		$slider.slider("value", 0);

		let targetCurveName = $slider.data("curve").split("-")[0];
		let targetCurve = $slider.data("curve").split("-")[1];
		let passIndex = $slider.data("pass-index");

		if (targetCurve == "Y") {
			lutify.getActiveBlock().passes[passIndex].enabled = false;
		} else {
			if (
				lutify.getActiveBlock().values.sliders[targetCurveName].R == 0 &&
				lutify.getActiveBlock().values.sliders[targetCurveName].G == 0 &&
				lutify.getActiveBlock().values.sliders[targetCurveName].B == 0
			) {
				lutify.getActiveBlock().passes[passIndex].enabled = false;
			}
		}
	}

	updateSliderUI($slider, sliderValue) {
		let $sliderControlElementHeight = $slider.height();
		let sliderControlFillHeight = Math.abs(($sliderControlElementHeight * sliderValue) / 2);
		let $sliderControlFillElement = $slider.find(".slider-control-fill");
		$sliderControlFillElement.css("height", `${sliderControlFillHeight}px`);

		if (sliderValue > 0) {
			$sliderControlFillElement.css({
				bottom: "50%",
				top: "initial",
			});
		} else if (sliderValue < 0) {
			$sliderControlFillElement.css({
				top: "50%",
				bottom: "initial",
			});
		}
	}

	opacitySliderHandler($element) {
		let opacityValue = $element.find(".opacity_slider").val();
		let calcOpacityValue = opacityValue * 0.01;

		$element.find(".opacity-input").val(opacityValue);

		lutify.getActiveBlock().opacity = opacityValue;
		lutify.getActiveBlock().passes.forEach(pass => {
			pass.uniforms.opacity.value = calcOpacityValue;
		})

		gpu.render();
	}

	opacityInputHandler($element) {
		let opacityValue = $element.find(".opacity-input").val();
		let opacitySlider = $element.find(".opacity_slider");

		if (opacityValue > this.opacity.maxValue) opacityValue = this.opacity.maxValue;
		if (opacityValue < this.opacity.minValue) opacityValue = this.opacity.minValue;

		opacitySlider.val(opacityValue);
		opacitySlider.trigger("input");
	}

	applyChanges($block, values, blockData) {
		Object.keys(values).forEach(control => {
			Object.keys(values[control]).forEach(curve => {
				$block
					.find(`.block-controls-container[data-control="${control}"] .slider-input-control[data-curve="${curve}-Y"]`)
					.val(values[control][curve].Y);
				$block
					.find(`.block-controls-container[data-control="${control}"] .slider-input-control[data-curve="${curve}-R"]`)
					.val(values[control][curve].R);
				$block
					.find(`.block-controls-container[data-control="${control}"] .slider-input-control[data-curve="${curve}-G"]`)
					.val(values[control][curve].G);
				$block
					.find(`.block-controls-container[data-control="${control}"] .slider-input-control[data-curve="${curve}-B"]`)
					.val(values[control][curve].B);
			});
		});

		$block.find('.block-controls-container[data-control="wheels"] .slider-input-control').trigger("change");
		$block.find('.block-controls-container[data-control="sliders"] .slider-input-control').trigger("change");

		if ('opacity' in blockData) {
			$block.find(".opacity-input").val(parseInt(blockData.opacity));
			$block.find(".opacity-input").trigger("change");
		}
	}
}
